import { styled, css } from "styled-components";
import { Colors } from "../../../styles";
const StyledProgressBar = styled.div `
  background: #f2f2f2;
  display: flex;
  justify-content: space-between;
  position: relative;

  ${({ direction, percentCompleted }) => {
    switch (direction) {
        case "vertical": {
            return css `
          width: 4px;
          flex-direction: column;
          &:before {
            content: " ";
            height: ${percentCompleted}%;
            width: 4px;
            position: absolute;
            left: 0;
            background: ${Colors.ALERT_SUCCESS};
          }
        `;
        }
        case "horizontal":
        default:
            return css `
          margin-bottom: 3rem;
          height: 4px;
          &:before {
            content: " ";
            width: ${percentCompleted}%;
            height: 4px;
            position: absolute;
            left: 0;
            background: ${Colors.ALERT_SUCCESS};
          }
        `;
    }
}}
`;
const StyledProgressStep = styled.div `
  position: relative;
  ${(props) => props.theme.direction === "vertical" &&
    css `
      display: flex;
      margin-left: -10px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    `}
`;
const Action = styled.div `
  position: absolute;
  top: 24px;
  transform: translateX(-50%);
  left: 50%;

  ${(props) => props.theme.direction === "vertical" &&
    css `
      position: initial;
      top: 0;
      left: 0;
      transform: none;
      margin-left: 12px;
    `}

  > * {
    white-space: nowrap;
  }
`;
const Step = styled.div `
  background: #f2f2f2;
  box-sizing: border-box;
  border-radius: 50%;
  margin-left: -12px;
  margin-top: -12px;
  height: 24px;
  width: 24px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;

  font-weight: 700;
  flex-shrink: 0;
  flex-grow: 0;
  svg {
    width: 8px;
  }

  ${({ isActive }) => isActive &&
    css `
      background: ${Colors.ALERT_SUCCESS};
      color: #fff;
    `}

  ${(props) => props.theme.direction === "vertical" &&
    css `
      margin-left: 0;
      margin-top: 0;
    `}
`;
const Bullet = styled.div `
  background: ${(props) => props.color ?? Colors.BLACK};
  min-width: ${(props) => props.radius ?? 8}px;
  min-height: ${(props) => props.radius ?? 8}px;
  border-radius: ${(props) => (props.radius ?? 8) / 2}px;
`;
const Styles = {
    StyledProgressBar,
    StyledProgressStep,
    Action,
    Step,
    Bullet,
};
export default Styles;
//# sourceMappingURL=styles.js.map